document.addEventListener("DOMContentLoaded", () => {
    const buttons = document.querySelectorAll(".tab-btn");
    const panels = document.querySelectorAll(".tab-panel");

    // ⬇️ Lire le paramètre d'URL
    const urlParams = new URLSearchParams(window.location.search);
    const defaultTab = (urlParams.get("tab") || "").replace(/\/+$/, "");

    function activateTab(tabName) {
        // Reset buttons
        buttons.forEach(btn => {
            btn.classList.remove("bg-dark", "text-primary-light");
            btn.classList.add("bg-main", "text-primary-dark");
        });

        // Activate selected button
        const activeBtn = document.querySelector(`.tab-btn[data-tab="${tabName}"]`);
        if (activeBtn) {
            activeBtn.classList.add("bg-dark", "text-primary-light");
            activeBtn.classList.remove("bg-main", "text-primary-dark");
        }

        // Toggle panels
        panels.forEach(panel => panel.classList.add("hidden"));
        const activePanel = document.querySelector(`#tab-${tabName}`);
        if (activePanel) activePanel.classList.remove("hidden");
    }

    // ⬇️ Si l’URL contient ?tab=..., activer cet onglet automatiquement
    if (defaultTab) {
        activateTab(defaultTab);
    } else {
        // Sinon activer le 1er onglet par défaut → "form"
        activateTab("form");
    }

    // Événements click sur les boutons
    buttons.forEach((button) => {
        button.addEventListener("click", () => {
            const target = button.getAttribute("data-tab");
            activateTab(target);
        });
    });
});
